import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, MessageCircle, Facebook, Instagram, Youtube, Twitter } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, ORG, whatsappLink } from "../../data/content";

const SOCIAL = [
  { icon: Facebook, label: "Facebook" },
  { icon: Instagram, label: "Instagram" },
  { icon: Twitter, label: "X" },
  { icon: Youtube, label: "YouTube" },
];

export const Footer = () => (
  <footer className="bg-navy text-slate-300 no-print" data-testid="site-footer">
    <div className="h-1 bg-gradient-to-r from-royal via-leaf to-royal" />
    <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
      <div className="lg:col-span-1">
        <Logo light />
        <p className="mt-6 font-display text-lg font-bold tracking-[0.15em] text-white">VOICE. RIGHTS. WELFARE.</p>
        <p className="mt-4 text-sm leading-relaxed">Affiliated to STU – Swatantra Thozhilali Union.<br />Associated with the Indian Union Muslim League (IUML).</p>
        <div className="mt-6 flex gap-2">
          {SOCIAL.map(({ icon: Icon, label }) => (
            <span key={label} title={`${label} – link coming soon`} className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-slate-400" data-testid={`footer-social-${label.toLowerCase()}`}>
              <Icon className="h-4 w-4" />
            </span>
          ))}
        </div>
      </div>
      <div>
        <h4 className="text-sm font-bold uppercase tracking-widest text-white">Quick Links</h4>
        <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="hover:text-emerald-300 transition-colors" data-testid={`footer-link-${n.to === "/" ? "home" : n.to.slice(1)}`}>{n.label}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-bold uppercase tracking-widest text-white">Get Support</h4>
        <ul className="mt-5 space-y-2.5 text-sm">
          <li><Link to="/membership" className="hover:text-emerald-300" data-testid="footer-apply">Apply for Membership</Link></li>
          <li><Link to="/membership?tab=track" className="hover:text-emerald-300" data-testid="footer-track">Track Application</Link></li>
          <li><Link to="/contact#grievance" className="hover:text-emerald-300" data-testid="footer-grievance">Register a Grievance</Link></li>
          <li><Link to="/legal-support#request" className="hover:text-emerald-300" data-testid="footer-legal">Request Legal Assistance</Link></li>
          <li><Link to="/news?tab=downloads" className="hover:text-emerald-300" data-testid="footer-downloads">Document Downloads</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-bold uppercase tracking-widest text-white">Contact</h4>
        <ul className="mt-5 space-y-3 text-sm">
          <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-emerald-300" />{ORG.address}</li>
          <li><a href={`tel:+91${ORG.phone}`} className="flex gap-3 hover:text-white" data-testid="footer-phone"><Phone className="h-4 w-4 text-emerald-300" />{ORG.phoneDisplay}</a></li>
          <li><a href={`mailto:${ORG.email}`} className="flex gap-3 hover:text-white" data-testid="footer-email"><Mail className="h-4 w-4 text-emerald-300" />{ORG.email}</a></li>
          <li><a href={whatsappLink()} target="_blank" rel="noreferrer" className="flex gap-3 hover:text-white" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-emerald-300" />WhatsApp enquiry</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col gap-3 py-6 text-xs text-slate-400 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} IT Employees Federation. All rights reserved.</p>
        <div className="flex gap-5">
          <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Use</Link>
          <Link to="/admin" className="hover:text-white" data-testid="footer-admin">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);
